import { LINE_HEIGHT, estimateStringWidth } from '@shopify/polaris-viz-core';

function estimateTextHeight({
  characterWidths,
  targetWidth,
  label
}) {
  const words = label.split(' ');
  let lines = 0;
  let lineWidth = 0;
  words.forEach((_, index) => {
    const wordParts = words[index].split('-');
    lines += wordParts.length;
    const wordWidth = estimateStringWidth(words[index], characterWidths);
    lineWidth += wordWidth;

    if (lineWidth > targetWidth) {
      lines += 1;
      lineWidth = wordWidth;
    }
  });
  return lines * LINE_HEIGHT;
}

export { estimateTextHeight };
